import type { ReactNode } from 'react';

import { Card } from '@/components/ui/card';
import {
  MediaButtons,
  type MediaButtonsProps,
} from '@/features/estate-media/components/media-buttons';
import { TabButtons } from '@/features/estate-media/components/tab-buttons';

export type MediaDataLayoutProps = {
  children?: ReactNode;
  page: string;
  isEditable?: boolean;
} & MediaButtonsProps;

export const MediaDataLayout = ({
  children,
  page,
  isEditable = true,
  ...props
}: MediaDataLayoutProps) => {
  return (
    <Card className="px-20 py-6 max-xl:px-10 max-sm:p-5">
      {isEditable ? (
        <div className="flex w-full justify-between">
          <TabButtons page={page} type="project" />
          <MediaButtons {...props} />
        </div>
      ) : null}
      {children}
    </Card>
  );
};
